angular.module('env.data.models', [

    'env.data.models.idModel',
    'env.data.models.baseModel',
    'env.data.models.customFieldAwareModel',

    'env.data.models.actionModel',
    'env.data.models.addressModel',
    'env.data.models.categoryModel',
    'env.data.models.categoryTypeModel',
    'env.data.models.centreModel',
    'env.data.models.commentModel',
    'env.data.models.customerModel',
    'env.data.models.documentModel',
    'env.data.models.orderItemModel',
    'env.data.models.orderModel',
    'env.data.models.stepModel',
    'env.data.models.userModel'

]);